(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Desktop mega-menu: klik-om-te-openen (geen hover-reis → wrap naar 2 rijen is prima). */
  (function () {
    var nav = document.querySelector('.mz-header__nav');
    if (!nav) return;

    function openItems() { return nav.querySelectorAll('.mz-nav__item.is-open'); }
    function close(li) {
      li.classList.remove('is-open');
      var a = li.querySelector('a');
      if (a) a.setAttribute('aria-expanded', 'false');
    }
    function closeAll(except) {
      openItems().forEach(function (li) { if (li !== except) close(li); });
    }

    nav.querySelectorAll('.mz-nav__item.has-children > a').forEach(function (a) {
      a.setAttribute('aria-haspopup', 'true');
      a.setAttribute('aria-expanded', 'false');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var li = a.parentElement;
        var willOpen = !li.classList.contains('is-open');
        closeAll(li);
        li.classList.toggle('is-open', willOpen);
        a.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });

    /* Klik buiten de nav → alles sluiten */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.mz-header__nav')) closeAll(null);
    });
    /* Escape → sluiten + focus terug op het geopende item */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = openItems()[0];
      closeAll(null);
      if (open) { var a = open.querySelector('a'); if (a) a.focus(); }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
